import React from 'react';
import {
  Dimensions,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import Ionicons from 'react-native-vector-icons/dist/Ionicons';
import {useTheme} from 'styled-components/native';

import BottomSheet from '../../../../../Interface/BottomSheet';
import {StepList} from '../../../../../Interface/List/StepList';
import {Button} from '../../../../../Interface/Forms/Buttons/Button';
import finesBanner from '../../../../../../assets/images/banners/multasbottomsheetcheckout.webp';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const BANNER_WIDTH = Dimensions.get('window').width;
const BANNER_HEIGHT = BANNER_WIDTH * (383 / 739);
const CONTENT_MAX_HEIGHT = Dimensions.get('window').height * 0.38;

export function FinesStepsModal({isOpen, onClose}: Props) {
  const theme = useTheme();

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      showHandle={false}
      aboveSheet={
        <Image
          source={finesBanner}
          style={styles.banner}
          resizeMode="cover"
        />
      }>
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
        bounces={false}>
        <View
          style={[
            styles.iconCircle,
            {backgroundColor: theme.colors.alert_blue_border},
          ]}>
          <Ionicons
            name="car"
            size={RFValue(28)}
            color={theme.colors.alert_blue_icon}
          />
        </View>
        <Text style={[styles.title, {color: theme.colors.title}]}>
          Parcele multas e débitos veiculares
        </Text>
        <Text style={[styles.subtitle, {color: theme.colors.text}]}>
          Veja como é fácil consultar e parcelar as multas e débitos do seu
          veículo direto pelo app:
        </Text>

        <View style={styles.steps}>
          <StepList
            number={1}
            text='Na tela inicial, toque no card "Multas e IPVA".'
          />
          <StepList number={2} text="Cadastre a placa do seu veículo." />
          <StepList
            number={3}
            text="Veja todas as multas e débitos em aberto."
          />
          <StepList
            number={4}
            text="Escolha o que quer pagar e parcele em até 12x."
          />
        </View>
      </ScrollView>

      <View style={styles.footer}>
        <Button title="Entendi" enabled onPress={onClose} />
      </View>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  banner: {
    width: BANNER_WIDTH,
    height: BANNER_HEIGHT,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    marginBottom: -RFValue(20),
  },
  scroll: {
    maxHeight: CONTENT_MAX_HEIGHT,
  },
  scrollContent: {
    paddingHorizontal: 24,
    paddingTop: 20,
    paddingBottom: 8,
    alignItems: 'center',
  },
  iconCircle: {
    width: RFValue(56),
    height: RFValue(56),
    borderRadius: RFValue(28),
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontFamily: 'Poppins-SemiBold',
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    fontFamily: 'Poppins-Regular',
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 20,
  },
  steps: {
    width: '100%',
    marginBottom: 12,
  },
  footer: {
    paddingHorizontal: 24,
    paddingTop: 12,
    paddingBottom: 12,
  },
});
